import { FunctionComponent } from 'react';

// utils
import classnames from 'classnames';

// Components
import Post from '@Components/UI/Post';
import Anchor from '@Components/Utils/Anchor';

// styles
import styles from './PostCard.module.scss';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';

interface PostProps {
    title?: string;
    posts?: Array<any>;
    className?: string;
}

const handleTrackingClickViewRelated = (title) => {
    gtag('event', 'click', {
        event_category: 'Posts',
        event_label: `View ${title}`,
    });
};

const PostCard: FunctionComponent<PostProps> = ({ className, title, posts }) => {
    const { deviceType } = useViewDetected();

    const isMobile = ['mobile', 'tablet'].includes(deviceType);

    const classNames = classnames([
        styles.post_card_wrapper,
        className,
        {
            [styles.mobile]: isMobile,
        },
    ]);

    return (
        <div className={classNames}>
            <div className={styles.title}>{title}</div>
            <div className={styles.items}>
                {posts?.map((post) => (
                    <Anchor key={`post-item-${post.id}`} href={`/bai-viet/${post.slug || post.id}`} className={styles.link} onClick={() => handleTrackingClickViewRelated(title)}>
                        <Post
                            isShowBadge
                            title={post.title}
                            image={post?.image}
                            className={styles.item}
                            category={post.category}
                            imageClassName={styles.image}
                            description={post.description}
                            imagePosition={isMobile ? 'right' : 'left'}
                            imageWrapperClassName={styles.image_wrapper}
                        />
                    </Anchor>
                ))}
            </div>
        </div>
    );
};

PostCard.defaultProps = {
    posts: [],
    className: '',
    title: 'Bài viết liên quan',
};

export default PostCard;
